/*import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}*/

import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule)
    //loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'landingPage',
    loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingPageModule)
  },
  {
    path: 'manageUserProfilePage',
    loadChildren: () => import('./pages/manage_user_profile/manage_user_profile.module').then(m => m.ManageUserProfilePageModule)
  },
  {
    path: 'managePetProfilePage',
    loadChildren: () => import('./pages/manage_pet_profile/manage_pet_profile.module').then(m => m.ManagePetProfilePageModule)
  },
  {
    path: 'petProfilePage',
    loadChildren: () => import('./pages/pet_profile/pet_profile.module').then(m => m.PetProfilePageModule)
  },
  {
    path: 'appointmentPage',
    loadChildren: () => import('./pages/appointment/appointment.module').then(m => m.AppointmentPageModule)
  },
  {
    path: 'appointmentDetailsPage',
    loadChildren: () => import('./pages/appointment_details/appointment_details.module').then(m => m.AppointmentDetailsPageModule)
  },
  {
    path: 'appointmentHistoryPage',
    loadChildren: () => import('./pages/appointment_history/appointment_history.module').then(m => m.AppointmentHistoryPageModule)
  },
  {
    path: 'examRoomPage',
    loadChildren: () => import('./pages/exam_room/exam_room.module').then(m => m.ExamRoomPageModule)
  },
  {
    path: 'medicalRecordPage',
    loadChildren: () => import('./pages/medical_record/medical_record.module').then(m => m.MedicalRecordPageModule)
  },
  {
    path: 'payPalPaymentPage',
    loadChildren: () => import('./pages/paypal_payment/paypal_payment.module').then(m => m.PayPalPaymentPageModule)
  },{
    path: 'braintreePaymentPage',
    loadChildren: () => import('./pages/braintree_payment/braintree_payment.module').then(m => m.BraintreePaymentPageModule)
  },{
    path: 'mediaViewerPage',
    loadChildren: () => import('./pages/media_viewer/media_viewer.module').then(m => m.MediaViewerPageModule)
  },
  {
    path: 'changePasswordPage',
    loadChildren: () => import('./pages/change_password/change_password.module').then(m => m.ChangePasswordPageModule)
  },
  {
    path: 'modal-content',
    loadChildren: () => import('./pages/modal-content/modal-content.module').then( m => m.ModalContentPageModule)
  },
  {
    path: 'forgotPasswordPage',
    loadChildren: () => import('./pages/forgot_password/forgot_password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'ratingPage',
    loadChildren: () => import('./pages/rating/rating.module').then(m => m.RatingPageModule)
  },
  {
    path: 'vetProfilePage',
    loadChildren: () => import('./pages/vet_profile/vet_profile.module').then(m => m.VetProfilePageModule)
  },
  {
    path: 'subscriptionsPage',
    loadChildren: () => import('./pages/subscriptions/subscriptions.module').then(m => m.SubscriptionsPageModule)
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
